var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        // Animations
        var supportsCssVariables = window.CSS && window.CSS.supports && window.CSS.supports("color", "var(--primary)");

        if (supportsCssVariables) {
            $("body").addClass("supports-css-variables");

            setTimeout(function () {
                var $elements = $(".animate__animated");

                if ($elements.length) {
                    $elements.waypoint({
                        handler: function (direction) {
                            var $element = $(this.element),
                                animation = $element.data("animation");

                            if (animation) {
                                $element
                                    .addClass("animate__" + animation)
                                    .css("visibility", "visible");
                            }
                        },
                        offset: "100%"
                    });
                }
            }, 1);
        }

        // Tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        });
    }

    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function BsElements() {

        const elements = {
            accPanels: [...$("[data-bs-toggle='collapse']")].filter(x => x.id != "").map(x => `#${x.id}`),
            tabPanels: [...$("[data-bs-toggle='tab']")].filter(x => x.id != "").map(x => `#${x.id}`),
            modals: [...$(".modal")].filter(x => x.id != "").map(x => `#${x.id}`)
        };

        const hash = location.hash;
        const bsType = Check(hash);
        if (bsType != false) { Execute(hash, bsType); }

        function Check(hash) {
            for (const key in elements) {
                if (elements[key].includes(hash)) {
                    return key;
                }
            }
            return false;
        }

        function Execute(hash, bsType) {
            if (bsType == "accPanels") {
                const target = $($(hash).attr("data-bs-target"));
                target.collapse("show");
            }
            else if (bsType == "tabPanels") {
                const target = $(hash);
                target.tab("show");
            }
            else if (bsType == "modals") {
                const target = $(hash);
                target.modal("show");
            }
        }

        return {
            Check: Check,
            Execute: Execute
        }

    }

    function SpeedBump() {

        const speedBumpModal = $("#ModalSpeedbump");
        const speedBumpExempt = Speedbump.exclusions;

        function Check(hostname, href) {

            if (hostname !== location.hostname
                && $.inArray(hostname, speedBumpExempt) === -1
                && href
                && href.indexOf("#") !== 0
                && !IsUriSchema(href)) {
                return true;
            }

            return false;
        }

        function Execute(href, parentModal) {

            // if speedbump was opened from a modal temporarily close modal when speedbump opens reopen modal when speedbump closes
            if (parentModal != null) {
                parentModal.modal("hide");
                speedBumpModal.on("hidden.bs.modal", function () {
                    parentModal.modal("show");
                })
            }

            speedBumpModal.modal("show");
            speedBumpModal.find("button[data-bs-proceed='modal']")
                .off("click")
                .on("click", function () {
                    speedBumpModal.modal("hide");
                    window.open(href);
                }
                );
        }

        function IsUriSchema(href) {

            const uriSchemes = ["javascript:", "mailto:", "tel:"];

            for (var i in uriSchemes) {
                if (href.indexOf(uriSchemes[i]) > -1) {
                    return true;
                }
            }
            return false;
        }


        return {
            Check: Check,
            Execute: Execute
        }

    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const hostname = this.hostname;
            const href = $(this).attr("href");

            // check against speedbump
            const isSpeedBump = SpeedBump().Check(hostname, href);

            if (isSpeedBump) {
                e.preventDefault();

                // see if the speedbump is triggered from within a modal that we would come back to
                const parentModal = $(this).parents(".modal");
                SpeedBump().Execute(href, parentModal);
            }

            // check against known bootstrap elements
            const bsType = BsElements().Check(href);

            if (bsType != false) {
                if (bsType == "modals") { e.preventDefault(); }
                BsElements().Execute(href, bsType);
            }
        });

    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    return {
        init: init,
        GetUrlParameter: GetUrlParameter,
        BsElements: BsElements,
        SpeedBump: SpeedBump,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables
    };

})(jQuery);

$(function () {
    App.Base.init();
    App.Base.BsElements();
    App.Base.ClickSupport($(".component-locations a"));
});